module.exports = __webpack_public_path__ + "static/media/smile-super.151ffb4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/smiles/smile-super.svg
// module id = 145
// module chunks = 0